export default "/images/b18f5e18e37d791f5c2d41bdb2fd16e3.avif";